import { makeAutoObservable, runInAction } from 'mobx'
import { restaurantCenter, storeMobx } from 'restaurant'
import { getLBSInfo, getPlatform, localStore } from '@utils'
import { boJudge, coordtransform } from '@dt/fe-utils'
import { H5LocationController, WxLocationController, ApLocationController } from '@ctrls/index'
import { wxConfigG } from 'controllers/third'

const { isWeixin, isAlipay, isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()

// chrome
// latitude: 22.3193039
// longitude: 114.1693611
// safari
// longitude: 120.1404501,
// latitude: 30.2931392
// 百度
// 120.21937542,
// lat: 30.25924446
const { BRANDID } = Config

/** 首页进入逻辑 */
class LocationStore {
  constructor () {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  /** 定位信息 */
  location = {} as ILocation

  /** 是否开启了LBS */
  locationIsOpen: boolean = false

  /** 当前定位所在的城市 */
  lbsCity: string = ''

  /** 地图类型 */
  get mapType (): 'baidu' | 'google' {
    return boJudge.checkKey('mapCn') ? 'baidu' : 'google'
  }

  /** 获取定位 */
  async getLocation () {
    let res: ILocation
    if (document.location.protocol.includes('https')) {
      // 走微信还是H5定位逻辑
      if ((isWeixin && wxConfigG.isInited()) || isWeixinMiniProgram) {
        res = await WxLocationController.init()
        console.log('location wx res', res)
        if (res.error && (res as any).invalid) {
          res = await H5LocationController.init()
        }
      } else if (isAlipay || isAliPayMiniProgram) {
        res = await ApLocationController.init()
        console.log('location alipay res', res)
        if (res?.longitude) {
          const [longitude, latitude] = coordtransform.gcj02towgs84(Number(res.longitude), Number(res.latitude))
          res = {
            ...res,
            longitude,
            latitude
          }
        }
        if (res.error) {
          res = await H5LocationController.init()
        }
      } else {
        res = await H5LocationController.init()
      }
      console.log('location res', res)
    } else {
      // 测试环境不走H5定位，H5定位得是https：可通过 npm run start-https 运行https项目
      res = {
        error: true,
        errorMsg: i18n.t('location.onlyHttps')
      } as ILocation
    }

    runInAction(() => {
      this.setLocationIsOpen(!!(res?.latitude && res?.longitude))
      this.setLocation({ ...res })
    })
    console.log('res: getLocation-location-mobx', res)
    return res
  }

  /** 浏览器获取的定位统一转为百度地图坐标 */
  transLoction (location: ILocation) {
    return location?.longitude && location?.latitude
      ? coordtransform.wgs84tobd09(location.longitude, location.latitude)
      : []
  }

  /** 设置定位 */
  setLocation (location: ILocation, isNoTran: boolean = true) {
    location = {
      ...location,
      longitude: location.longitude ? Number(location.longitude) || 0 : 0,
      latitude: location.latitude ? Number(location.latitude) || 0 : 0,
    }
    const [longitude, latitude] = isNoTran ? this.transLoction(location) : [location.longitude, location.latitude]
    this.location = {
      ...location,
      longitude,
      latitude
    }
    restaurantCenter.setConfig({
      lbs: {
        lat: latitude,
        lng: longitude
      }
    })
  }

  /** 获取lbs城市 */
  async getCityInfo (location: ILocation) {
    const mapType = this.mapType
    try {
      let { city, lbsAddress }: any = await getLBSInfo({ lng: location.longitude, lat: location.latitude }, mapType)
      runInAction(() => {
        this.lbsCity = city
        restaurantCenter.setConfig({
          cityName: city,
          lbsAddress,
        })
      })
    } catch (error) {
    }
    return true
  }

  /** 设置定位是否被拒绝 */
  setLocationIsOpen (isOpen: boolean) {
    this.locationIsOpen = isOpen
    localStore.set(`${BRANDID}_HANDTOP_LOCATION_ISOPEN`, isOpen)
  }
}
export default new LocationStore()
